import React from 'react';
import { useDispatch } from 'react-redux';

import AccountList from '../Lists/AccountList';

import { hideModal } from '../../actions/modal/modal';
import { mainviewActions } from '../../helpers/constants';

const AccountManagement = () => {

  const dispatch = useDispatch();

  const _closeModal = () => {
    dispatch(hideModal());
    dispatch({ type: mainviewActions.REMOVE_USER_ACCOUNT_LIST });
  }

  return (
    <>
      <span className="modal__close" onClick={ () => _closeModal() }>&times;</span>

      <h3 className="modal__header">Manage User Accounts</h3>

      <AccountList />
    </>
  );

}

export default AccountManagement;